import { Fe87v2DeviceList } from '@/define/device_vendor'
import { DataProfileForDecorate, LightModeParam } from '../../../libs/types/response'
import { deviceManager } from '../../device/device_manager'
import { dataProfileManage } from '../../snapshot/profile'
import { type KK } from '../../define/define'
import { DecorateLight } from '@/service/response'

export const handleSetLed = async (param: LightModeParam) => {
  const config = dataProfileManage().dataProfile
  config.LightLastIsCustom = false
  config.LightMode = param
  syncLightParam(false)
  dataProfileManage().save()
  return deviceManager.deviceDriver.syncLeds()
}

export const handleSetLedDecoration = async (param: DecorateLight[]) => {
  const config = dataProfileManage().dataProfile

  const data: DataProfileForDecorate[] = []
  for (let i = 0; i < param.length; i++) {
    const paramMap = new Map<KK, number>()
    const decorate = param[i]
    for (const [key, value] of Object.entries(decorate.ColorsCustom)) {
      paramMap.set(Number(key) as KK, value)
    }
    data.push({
      LightLastIsCustom: decorate.LightLastIsCustom,
      LightMode: decorate.LightMode,
      ColorsCustom: paramMap,
      ColorsDynamic: {
        Color: decorate.ColorsDynamic.Color,
        FullColor: decorate.ColorsDynamic.FullColor,
        Mode: decorate.ColorsDynamic.Mode,
        Run: decorate.ColorsDynamic.Run,
        IsEEvision: decorate.ColorsDynamic.IsEEvision,
      },
    })
  }
  config.Decorates = data
  syncLightParam(true)
  dataProfileManage().save()
  return deviceManager.deviceDriver.syncDecorationLed()
}

const syncLightParam = (isSetDecoration: boolean) => {
  const config = dataProfileManage().dataProfile
  if (Fe87v2DeviceList.includes(deviceManager.deviceID) && config.Decorates && config.Decorates.length > 0) {
    if (isSetDecoration) {
      config.LightMode.Light = config.Decorates[0].LightMode.Light
      config.LightMode.Speed = config.Decorates[0].LightMode.Speed
      config.LightMode.Colors = config.Decorates[0].LightMode.Colors
      config.LightMode.Color = config.Decorates[0].LightMode.Color
      config.LightMode.Direction = config.Decorates[0].LightMode.Direction
    } else {
      config.Decorates[0].LightMode.Light = config.LightMode.Light
      config.Decorates[0].LightMode.Speed = config.LightMode.Speed
      config.Decorates[0].LightMode.Colors = config.LightMode.Colors
      config.Decorates[0].LightMode.Color = config.LightMode.Color
      config.Decorates[0].LightMode.Direction = config.LightMode.Direction
    }
  }
  dataProfileManage().save()
}
